/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 * Sorting Type
 */
export enum SortingTypeEnum {
    ASC = 'ASC',
    DESC = 'DESC',
}